<template>
  <div class="content-main">
    <div class="box-item"   @click="submitButton(info.id)" style=" cursor: pointer;">
      <p>{{ info.title }}</p>
      <p> {{ dayjs(info.release_time * 1000).format("YYYY-MM-DD") }}</p>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});


const props = defineProps({
  ulLi: {
    type: Array,
    default: () => {
      return [
        // {
        //   title: "二轮复习必备神器二轮复习必备神器",
        //   time: "2024-07-12",
        // },

        // {
        //   title:
        //     "福建省高等学校招生委员会福建省教育厅关于做好2024年普通高等学校招生考试报名工作的通知",
        //   time: "2024-07-01 ",
        // },
        // {
        //   title:
        //     "福建省高等学校招生委员会福建省教育厅关于做好2024年普通高等学校招生考试报名工作的通知",
        //   time: "2024-07-02",
        // },
        // {
        //   title:
        //     "福建省高等学校招生委员会福建省教育厅关于做好2024年普通高等学校招生考试报名工作的通知",
        //   time: "2024-07-03 ",
        // },
        // {
        //   title:
        //     "福建省高等学校招生委员会福建省教育厅关于做好2024年普通高等学校招生考试报名工作的通知",
        //   time: "2024-07-04 ",
        // },
        // {
        //   title:
        //     "福建省高等学校招生委员会福建省教育厅关于做好2024年普通高等学校招生考试报名工作的通知",
        //   time: "2024-07-02",
        // },
        // {
        //   title:
        //     "福建省高等学校招生委员会福建省教育厅关于做好2024年普通高等学校招生考试报名工作的通知",
        //   time: "2024-07-03 ",
        // },
        // {
        //   title:
        //     "福建省高等学校招生委员会福建省教育厅关于做好2024年普通高等学校招生考试报名工作的通知育厅关于做好2024年普通高等学校招生考试报名工作的通知",
        //   time: "2024-07-04 ",
        // },
      ];
    },
  },

   path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});


//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query:{id}
  });
}




</script>

<style scoped lang="scss">
.content-main {
 
  .box-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    position: relative;
    > p:nth-of-type(1) {
      width: 200px;
      height: 24px;
      // border:1px solid rgb(0, 255, 85);
      line-height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-left: 15px;

      white-space: nowrap; //不折行
      text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;
    }
    > p:nth-of-type(2) {
      // width:119px;
      height: 24px;
      // border:1px solid red;
      line-height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }
  }
  // .box-item:nth-last-of-type(1) {
  //   margin-bottom: 0px;
  // }
  .box-item::before {
    content: "";
    position: absolute;
    display: block;
    top: 9px;
    left: 0px;
    width: 7px;
    height: 7px;
    background-color: #dcdee2;
    border-radius: 3.5px;
  }

  .box-item:hover {
    p {
      color: #009de0;
    }
  }
  .box-item:hover::before {
      content: "";
      position: absolute;
      display: block;
      top: 9px;
      left: 0px;
      width: 7px;
      height: 7px;
      border-radius: 3.5px;
      background-color: #009de0 !important;
    }
}
</style>